import { Component, OnInit } from '@angular/core';
import { User } from '../../models/user.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import { UserService } from '../../services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FuseConfirmationService } from '../../../@fuse/services/confirmation';
import { Role } from 'app/models/role.model';
import { RoleService } from 'app/services/role.service';
import { UserService as _UserService } from 'app/core/user/user.service';
import { environment } from '../../../environments/environment';
@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

    users: User[] = [];
    roles: Role[] = [];
    isLoaded: boolean = false;
    currentUser: User = new User();
    errors: string[] = [];
    success: boolean = false;
    error: boolean = false;
    messageErreur: string = '';
    unsavedChanges: boolean = false;


    userForm: FormGroup;

    private routeSub: Subscription;

    constructor(
        private userService: UserService,
        private roleService: RoleService,
        private route: ActivatedRoute,
        private router: Router,
        private fuseConfirmationService: FuseConfirmationService,
        private _userService: _UserService,
        private _httpClient: HttpClient
    ) { }

    ngOnInit(): void {
        this.getUsers();
        this.getRoles();
        this.userForm = new FormGroup({
            prenom: new FormControl(this.currentUser.prenom, [Validators.required]),
            nom: new FormControl(this.currentUser.nom, [Validators.required]),
            email: new FormControl(this.currentUser.email, [Validators.required, Validators.email]),
            password: new FormControl('', [Validators.required]),
            role_id: new FormControl('', this.isAdmin ? [Validators.required] : []),
        });

        // Subscribe to form value changes
        this.userForm.valueChanges.subscribe(() => {
            this.unsavedChanges = true;
        });

        //Migrate helper
        window['migrate'] = () => {
            console.log("Migration en cours...");
            this._httpClient.post(environment.API_URL + 'migrate', {}).subscribe((response) => {
                console.log(response);
            });
        };
    }

    getUsers(): void {
        this.userService.getUsers().subscribe((users) => {
            this.users = users;
            this.isLoaded = true;
            this.routeSub = this.route.params.subscribe((params) => {
                if (params['id'] != null) {
                    this.edit(params['id']);
                    this.router.navigate(
                        ['.'],
                        { relativeTo: this.route, queryParams: {} }
                    );
                }
            });
        });
    }

    getRoles(): void {
        this.roleService.getRoles().subscribe((roles) => {
            this.roles = roles;
        });
    }

    setForm() {
        if (this.currentUser != null) {
            this.userForm.patchValue({
                prenom: this.currentUser.prenom,
                nom: this.currentUser.nom,
                email: this.currentUser.email,
                role_id: this.currentUser.role_id,
            });
        }

        if (this.currentUser.id != null) {
            this.userForm.controls.password.setValidators([]);
            this.userForm.controls.password.updateValueAndValidity();
        }
    }

    get f() {
        return this.userForm?.controls;
    }

    onFormSubmit() {
        this.success = false;
        this.error = false;
        this.userForm.markAllAsTouched();

        if (this.userForm.valid) {
            const user = new User(this.userForm.value);
            if (this.currentUser.id != 0) {
                this.userService.update(user, this.currentUser.id).subscribe(
                    (response) => {
                        this.routeSub = this.route.params.subscribe((params) => {
                            if (params['id'] != null) {
                                this.edit(params['id']);
                                this.router.navigate(
                                    ['/utilisateurs'],
                                    { relativeTo: this.route, queryParams: {} }
                                );
                            }
                        });
                        this.success = true;
                        this.getUsers();
                        this.unsavedChanges = false;
                    }, (error) => {
                        if (error.error != null && error.error.errors != null && error.error.errors.email != null && error.error.errors.email.length > 0 && error.error.errors.email[0] == 'Le champ email est déjà utilisée.') {
                            this.messageErreur = 'Le courriel est déjà utilisé.';
                        }
                        else {
                            this.messageErreur = 'Erreur lors de l\'enregistrement, réessayez!';
                        }
                        this.error = true;
                        this.showErrors(error);
                    }
                );
            } else {
                this.userService.store(user).subscribe(
                    (response) => {
                        this.routeSub = this.route.params.subscribe((params) => {
                            if (params['id'] != null) {
                                this.edit(params['id']);
                                this.router.navigate(
                                    ['/utilisateurs'],
                                    { relativeTo: this.route, queryParams: {} }
                                );
                            }
                        });
                        this.success = true;
                        this.getUsers();
                        this.currentUser = new User();
                        this.unsavedChanges = false;
                    }, (error) => {
                        if (error.error != null && error.error.errors != null && error.error.errors.email != null && error.error.errors.email.length > 0 && error.error.errors.email[0] == 'Le champ email est déjà utilisée.') {
                            this.messageErreur = 'Le courriel est déjà utilisé.';
                        }
                        else {
                            this.messageErreur = 'Erreur lors de l\'enregistrement, réessayez!';
                        }
                        this.error = true;
                        this.showErrors(error);
                    }
                );
            }
        }
    }

    add() {
        this.errors = [];
        if (this.currentUser.id != 0) {
            const article = new User();
            article.id = 0;
            this.users.unshift(article);
            this.currentUser = article;
            this.userForm.reset();
            this.userForm.controls.password.setValidators([Validators.required]);
        }
    }

    edit(id: number) {
        this.errors = [];
        if (this.users[0].id === 0) {
            this.users.shift();
        }
        if (this.currentUser.id == id) {
            this.currentUser = new User();
        }
        else {
            this.userService.getUser(id).subscribe((user) => {
                this.currentUser = user;
                this.setForm();
            });
        }
    }

    delete(id: number): void {
        if (this.isAdmin) {
            const confirmation = this.fuseConfirmationService.open({
                title: 'Suppression d\'un utilisateur',
                message: 'Êtes-vous certain de vouloir supprimer cet utilisateur',
                actions: {
                    confirm: {
                        label: 'Supprimer'
                    }
                }
            });

            confirmation.afterClosed().subscribe((result) => {
                if (result === 'confirmed') {
                    this.userService.delete(id).subscribe((response) => {
                        this.users = this.users.filter(x => x.id != id);
                        //this.toastr.success("L'utilisateur a été supprimé");
                    },
                        (error) => {
                            console.log(error); this.showErrors(error);
                        });
                }
            });
        }
    }

    get isAdmin(): boolean {
        return this._userService.getCurrentUser().role_id == 1;
    }

    compareRolesSelect(role1: any, role2: any): boolean {
        return role1 == role2;
    }

    showErrors(error: any) {
        //Gestion des erreurs laravel
        if (error instanceof HttpErrorResponse) {
            // Todo: handle error
        }
        else {
            error.forEach((element) => {
                //this.toastr.error(element);
            });
        }
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    hasUnsavedChanges(): Observable<boolean> {
        if (this.unsavedChanges) {
            return new Observable<boolean>(observer => {
            this.fuseConfirmationService.open().afterClosed().subscribe(result => {
                if (result === 'confirmed') {
                observer.next(true);  // Allow navigation
                } else {
                observer.next(false);  // Prevent navigation
                }
                observer.complete();
            });
            });
        }
    }
}
